import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyName = microserviceNames.stakeholderMicroserviceWithoutToken;

export async function getTranslations() {
  return (await Axios.get(`${proxyName}/${Urls.Translation}/getAll`)).data;
}

// export async function addTranslationKey(key) {
//   if (!key) {
//     return;
//   }
//   return (await Axios.post(`${API_URL}/${Urls.Translation}`, { key })).data;
// }
